module.exports = __webpack_public_path__ + "static/img/indomaret.8638135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indomaret.png
// module id = o1ju
// module chunks = 1